export const navigationActionData = [
  {
    name: 'goToPage',
    label: 'Page Redirect',
    args: [
      {
        name: 'destination',
        label: 'Destination',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'isNewTab',
        label: 'Open In New Page',
        type: 'boolean',
        value: '',
        custom: [],
        asRadio: true,
      },
      {
        name: 'sendCurrentObjectID',
        label: 'Send Current Item ID',
        type: 'boolean',
        value: '',
        custom: [],
        asRadio: true,
      },
      {
        name: 'sendPreviousStepParentCollectionId',
        label: 'Send Item ID from Previous Step',
        type: 'boolean',
        value: '',
        custom: [],
        asRadio: true,
      },
      {
        name: 'sendCurrentPageItemId',
        label: 'Send Item ID of Current Page',
        type: 'boolean',
        value: '',
        custom: [],
        asRadio: true,
      },
      {
        name: 'sendCurrentUserId',
        label: 'Send Current LoggedIn User ID',
        type: 'boolean',
        value: '',
        custom: [],
        asRadio: true,
      },
      {
        name: 'sendTargetItemID',
        label: 'Send Link/Button Item ID',
        type: 'boolean',
        value: '',
        custom: [],
        asRadio: true,
      },
      {
        name: 'sendCurrentPageReferenceItemId',
        label: 'Send Item ID of Current Page Reference Item',
        type: 'boolean',
        value: '',
        custom: [],
        asRadio: true,
      },
      {
        name: 'collection',
        label: 'Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'referenceField',
        label: 'Reference Field',
        type: 'dropdown',
        optionsType: 'fieldApi',
        options: [],
        value: '',
      },
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'dynamicPageRedirect',
    label: 'Conditional Redirect',
    args: [
      {
        name: 'collectionFrom',
        label: 'Collection From',
        type: 'radio',
        optionsType: '',
        value: 'collections',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      {
        name: 'collectionName',
        label: 'Collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldName',
        label: 'Collection Field',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'customPageRedirect',
    label: 'Custom Page Redirect',
    args: [
      {
        name: 'redirectValueFrom',
        label: 'Get redirect value from',
        type: 'dropdown',
        optionsType: 'redirectFromOptions',
        options: [],
        value: 'CUSTOM_URL',
      },
      {
        name: 'destination',
        label: 'Destination',
        placeholder: 'Eg. https://google.com or, data.url',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
    ],
  },
  {
    name: 'reloadPage',
    label: 'Page Reload',
    args: [],
  },
  {
    name: 'switchLocalizationLang',
    label: 'Switch Language',
    args: [
      {
        name: 'language',
        label: 'Select Language',
        type: 'dropdown',
        optionsType: 'localizationApi',
        options: [],
        value: '',
      },
    ],
  },
];
